import { render } from "./InfoPrivacy.vue?vue&type=template&id=19aad4f0"
import script from "./InfoPrivacy.vue?vue&type=script&lang=js"
export * from "./InfoPrivacy.vue?vue&type=script&lang=js"

import "./InfoPrivacy.vue?vue&type=style&index=0&id=19aad4f0&lang=scss"

import exportComponent from "/srv/volumes/sshfs-rpi3ex/bylex_platform/account/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__